import { useMutation } from '@apollo/client';

import {
  RestartBillMutation,
  RestartBillMutationVariables,
} from '../graphql/generated';
import { RESTART_BILL } from '../graphql/mutations';

const useRestartBill = () => {
  const [restartBill, result] = useMutation<
  RestartBillMutation,
  RestartBillMutationVariables
  >(RESTART_BILL);

  return {
    restartBill,
    ...result,
  };
};

export default useRestartBill;